import * as React from 'react';
import ButtonComponent from '../../../components/UI/Button/Button.component';
import type { GlobalButtonProps } from '../../../interfaces/globals.interface';

/**
 * ConfirmAction method renders a button component with a confirm action label
 *
 * @param {GlobalButtonProps} props - The props for the ConfirmAction method
 * @param {string} props.confirmActionLabel - The label for the confirm action button
 * @param {function} props.onClick - The callback function for when the button is clicked
 *
 * @return {React.ReactElement} - The rendered button component with the confirm action label
 */
const ConfirmAction = (props: GlobalButtonProps): React.ReactElement => {
  const { confirmActionLabel, onClick, className, type, disabled } = props;
  return (
    <ButtonComponent
      className={className}
      variant="primary"
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {confirmActionLabel as string}
    </ButtonComponent>
  );
};

export default ConfirmAction;
